<template>
    <transition name="fade">
        <div v-if="show_tip" id="pushMessageContainer">
            <div class="pushMessage" v-if="tip_object.content">
                <!-- <div class="pushMessageClose">
                    <div class="pushMessageCloseBox" @click="close()">
                        <span></span>
                    </div>
                </div> -->
                <div class="pushMessageBox" @click="click()" title="click to view details">
                    <!-- <div class="pushMessageBoxTitle">
                        <span class="pushMessageBoxTitleMain">{{ tip_object.title || 'Default title'}}</span> <span class="pushMessageBoxTitleSmall">form PCBCart</span>
                    </div> -->
                     <span class="pushMessageCloseSpan" @click="close()"></span>
                    <div class="pushMessageBoxContent">
                        <div ref="tip_container" class="pushMessageBoxContentMain" :class="[ css3 ? 'support_line_clamp' : '', no_ellipis ? 'no_ellipis' : '']">
                            <div v-html="tip_object.content"></div>
                        </div>
                    </div>
                </div>
                <div class="pushMessageHeadImage"></div>
            </div>
            </div>
    </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import api from '../api'

export default {
    computed: {
        ...mapState(['show_tip', 'tip_object', 'user', 'message_open', 'open_modal'])
    },
    data() {
        return {
            css3: false,
            no_ellipis: false,
            data: {}
        }
    },
    watch: {
        tip_object(val) {
            if (val.id) this.data = val
        },
        data() {
            this.tipEvent()
        }
    },
    methods: {
        ...mapMutations(['showTip', 'closeTip', 'switchModal', 'updateTip']),
        close() {
          event.stopPropagation()
          this.closeTip()
        },
        click() {
            this.closeTip()
            this.switchModal()
            if (this.user.uuid) {
                this.$remote.$emit('marketingmessage', {
                    conversation_id: 0,
                    to_user_uuid: this.user.uuid,
                    data: this.tip_object.content,
                    type: 'admin'
                })
            } else {
                
            }
        },
        tipEvent() {
            let seconds = 2000
            let data = this.tip_object
            if (data.hasOwnProperty('conditions') && data.conditions.length > 0) {
                data.conditions.forEach((condition, index ) => {
                    if (condition.condition_name === 'seconds') {
                        seconds = condition.value1 * 1000
                    }
                })
            } else {
                this.updateTip({})
                return
            }
            var OLD_MD5_VERSION = localStorage.getItem('PCBCART_PUSH_MESSAGE_' + data.id)
            if (OLD_MD5_VERSION === data.md5) {
                this.updateTip({})
                return
            }

            if (supportCss3('line-clamp')) this.css3 = true
            // if (this.$refs.tip_container.height < 30) this.no_ellipis = true
            setTimeout(() => {
                this.showTip()
                this.pushShowTimes()
            }, seconds)
        },
        pushShowTimes() {
            fetch(`${api.baseUrl}/pushMessage/plusShowTimes`, {id: this.tip_object.id})
        },
        plusOpenTimes() {
            fetch(`${api.baseUrl}/pushMessage/plusOpenTimes`, {id: this.tip_object.id})
        },
        plusClickTimes() {
            fetch(`${api.baseUrl}/pushMessage/plusClickTimes`, {id: this.tip_object.id})
        },
    }
}

function supportCss3(style) {
	var prefix = ['webkit', 'moz', 'ms', 'o'],
		i,
		humpString = [],
		htmlStyle = document.documentElement.style,
		_toHumb = function(string) {
			return string.replace(/-(\w)/g, function($0, $1) {
				return $1.toUpperCase()
			})
		}

	for (i in prefix)
		humpString.push(_toHumb(prefix[i] + '-' + style))

	humpString.push(_toHumb(style))

	for (i in humpString)
		if (humpString[i] in htmlStyle) return true

	return false
}

</script>


<style lang="scss" scoped>
#pushMessageContainer {
    z-index: 2147483000;
    position: fixed!important;
    bottom: 85px;
    text-align: left;
    right: 10px;
    max-height: calc(100% - 20px + 10px);
    width: 360px!important;
    box-sizing: border-box;
    font-family: Candara,"Helvetica Neue",Helvetica,Arial,sans-serif;
    * {box-sizing: border-box;}
	.pushMessage {
	    padding: 10px;
	    display: block;
		&Close {position: relative; height: 52px;}
    .pushMessageCloseSpan {
        display: block;
        font-size: 13px;
        height: 32px;
        line-height: 32px;
        padding: 0 8px;
        border-radius: 16px;
        cursor: pointer;
        background-position: 50%;
        padding-right: 16px;
        padding-left: 16px;
        background-image: url(../assets/dismiss.png);
       background-size: 10px 10px;
        background-repeat: no-repeat;
        position: absolute;
        right:0;
        top: 3px;
    }
		&Box {
		    position: relative;
    		border-radius: 6px 6px 0 6px;
		    background-color: #fff;
			box-shadow: 0 2px 8px 0 rgba(35,47,53,.09);
			padding: 30px 0 15px;
			margin-left: 45px;
			&Title {
			    font-size: 14px;
			    color: #263238;
			    padding: 15px 20px 10px;
		        overflow: hidden;
			    &Small {
		    	    white-space: nowrap; color: rgba(73,76,93,.7);font-size: 12px;
			    }
			}
			&ContentMain {
			    padding: 0 20px;
			    position: relative;
			    color: #6e7a89;
			    line-height: 1.8em;
				overflow: hidden;
				word-break: break-word;
                overflow-x: hidden;
				overflow-y: auto;
				max-height: 520px;
		        text-overflow: initial;  
		        -webkit-box-orient: initial;  
		        -webkit-line-clamp: initial;  
		        &::after {content: '';}
				img {
					display: block;
					margin: .5rem 0;
				}
				
				&::after {
					content: "...";
				    color: #b9b9b9;
				    position:absolute;
				    bottom: 0;
				    right: 20px;
				    padding: 0 15px 1px 25px;
				    // background:url(../assets/ellipsis_bg.png) repeat-y;
				}
				img {
					display: none;
					max-width: 100%;
					border: 2px solid transparent;
					outline: none;
				}
				&.support_line_clamp {
					&::after {
						content: '' !important;
					}
					display: -webkit-box;  
					display: -moz-box;  
					text-overflow: ellipsis;  
					-webkit-box-orient: vertical;  
					-webkit-line-clamp: 2;
				}
				&.no_ellipis {
					&::after {content: ''}
				}
			}
			&::after {
			    content: "";
			    position: absolute;
			    bottom: 0;
			    left: 99%;
			    width: 0;
			    height: 0;
			    border-style: solid;
			    border-width: 0 5px 12px 0;
			    border-color: transparent transparent #fff;
			}
		}
		
	}
}
.fade-enter-active, .fade-leave-active {
  transition: all .35s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; transform: translateY(8px);
}
</style>


// WEBPACK FOOTER //
// src/components/ChatTip.vue